import ReactCountryFlag from 'react-country-flag'
import { Box, Typography } from '@material-ui/core'

import helpers from 'helpers'

import theme from 'theme'
import useStyles from './styles'

const PhoneDisplay = ({ value, ...rest }) => {
  const { details, number } = helpers.formatters.phone

  const classes = useStyles()

  const phoneNumber = number(value)

  return (
    <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
      <ReactCountryFlag
        countryCode={details(value)?.country || 'BR'}
        svg
        className={classes.flag}
      />
      <Typography {...rest}>{phoneNumber || 'Não informado'}</Typography>
    </Box>
  )
}

export default PhoneDisplay
